import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import SectionHeading from "./SectionHeading";
import { TechVideo } from "./TechVideo";

const TechDrivenSection = () => {
  const { lang } = useLanguage();
  const t = content[lang].tech;

  return (
    <section className="relative py-24 md:py-28 bg-narwhal-panel/40 border-y border-white/5" data-testid="tech-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionHeading kicker={t.kicker} title={t.title} body={t.body} />
          <div className="mt-8 flex flex-wrap gap-2.5" data-testid="tech-capabilities-list">
            {t.list.map((item, index) => (
              <span key={item} className="inline-flex items-center gap-2 rounded-full border border-white/12 bg-white/[0.03] px-4 py-2 text-sm text-white/75" data-testid={`tech-capability-${index}`}>
                <Check className="w-3.5 h-3.5 text-narwhal-teal" aria-hidden="true" />{item}
              </span>
            ))}
          </div>
        </div>

        <TechVideo lang={lang} video={t.video} note={t.note} />
      </div>
    </section>
  );
};

export default TechDrivenSection;
